<script lang="ts">
  export let category: string = 'Other';
  export let size: number = 24;

  const icons: Record<string, string> = {
    'PDF': 'M6 2a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6H6zm7 1.5L18.5 9H15a2 2 0 01-2-2V3.5zM9 13h2v2h1v-2h2v-1h-2v-2h-1v2H9v1z',
    'Images': 'M4 5a2 2 0 012-2h12a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm16 10l-4-4-4 4-3-3-3 3V5h14v10zM8 9a2 2 0 100-4 2 2 0 000 4z',
    'Audio/Video': 'M12 3v18m-4.5-4.5l-3 3m0-13.5l3 3M9 12H3m13.5 4.5l3 3m0-13.5l-3 3M15 12h6',
    'Data': 'M3 3v18h18M7 16l4-5 3 3 5-7',
    'Text': 'M4 7V4h16v3M9 20h6M12 4v16',
    'QR': 'M3 3h7v7H3V3zm1 1v5h5V4H4zm10-1h7v7h-7V3zm1 1v5h5V4h-5zM3 14h7v7H3v-7zm1 1v5h5v-5H4zm13 0h1v1h-1zm-3-1h1v3h3v1h-1v3h-1v-3h-1v3h-1v-1h-1v-1h2v-1h-1v-3z',
    'Sharing': 'M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71',
    'Games': 'M6 11h4M8 9v4m6 0h.01M18 11h.01M17.32 5H6.68a4 4 0 00-3.978 3.59C2.23 11.77 2 15.28 2 16.5a3.5 3.5 0 006.56 1.69l.8-1.19h5.28l.8 1.19A3.5 3.5 0 0022 16.5c0-1.22-.23-4.73-.7-7.91A4 4 0 0017.32 5z',
    'Docs & Forms': 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
    'Privacy': 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
    'Productivity': 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
    'Other': 'M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z'
  };

  const colors: Record<string, string> = {
    'PDF': 'var(--cat-pdf)',
    'Images': 'var(--cat-images)',
    'Audio/Video': 'var(--cat-av)',
    'Data': 'var(--cat-data)',
    'Text': 'var(--cat-text)',
    'QR': 'var(--cat-qr)',
    'Sharing': 'var(--cat-sharing)',
    'Games': 'var(--cat-games)',
    'Docs & Forms': 'var(--cat-docs)',
    'Privacy': 'var(--cat-privacy)',
    'Productivity': 'var(--cat-productivity)',
    'Other': 'var(--cat-other)',
  };

  $: path = icons[category] || icons['Other'];
  $: color = colors[category] || colors['Other'];
</script>

<div class="cat-icon" style="--cat-color: {color}; width: {size}px; height: {size}px;">
  <svg viewBox="0 0 24 24" fill="none" stroke="hsl({color})" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width={size} height={size}>
    <path d={path} />
  </svg>
</div>

<style>
  .cat-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
</style>
